module.exports = __webpack_public_path__ + "img/banner.2acdd4dc.jpg";